import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Chart, ChartDataset, registerables } from 'chart.js';
import { Subscription } from 'rxjs';
import { CommonHandler } from 'src/app/shared/handlers/common-handler';
import { PrecisionType } from 'src/app/shared/interfaces/chart.model';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
Chart.register(...registerables);

@Component({
  selector: 'app-other-capex-chart',
  templateUrl: './other-capex-chart.component.html',
  styleUrls: ['./other-capex-chart.component.scss'],
})
export class OtherCapexChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() capexData: any;
  @Input() showTimeFrameModeToggle = true;

  public enableWaterfallGraph: false;
  public aggregatedData = [];
  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  public timeFrameMode: TimeFrameMode;
  public regionKeys: any = [];
  public chartParams = [];
  public chartData = {
    year: {},
    quarter: {},
  };

  private subs = new Subscription();

  constructor(
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.timeFrameMode) {
      this.prepareChart();
      this.aggregatedData = this.aggregator();
    }
  }

  ngOnInit(): void {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        if (filter) {
          this.yearRange.startYear = filter.start_year;
          this.yearRange.endYear = filter.end_year;
        }
      }),
    );
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
        this.prepareChart();
        this.aggregatedData = this.aggregator();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private prepareChart() {
    this.chartParams = [];
    this.regionKeys = Object.keys(this.capexData.year).filter((ele) => !['total', 'Building up'].includes(ele));
    // const backgroundColors = ['#2E2E38 ', '#747480', '#C4C4CD', '#E1E1E6'];
    const backgroundColors = ['#281138', '#421C5D', '#6C4688', '#A68FB7', '#E1E1E6', '#FAF3E3', '#FDE2B2', '#FBCC79', '#FBCC79'];

    this.regionKeys.forEach((key, index) => {
      this.chartParams.push({
        name: key,
        type: 'bar',
        label: key,
        color: backgroundColors[index],
        stacked: true,
        precision: PrecisionType.NONE,
        legend: { isTop: true, isRight: false },
      });
      this.chartData[this.timeFrameMode][key] = this.calculateVals(key);
    });

    this.chartData = CommonHandler.getCopy(this.chartData);
  }

  private calculateVals(type) {
    return this.capexData[this.timeFrameMode][type].map((el) => this.formatNumbers(el));
  }

  private formatNumbers(amt: number) {
    if (!amt) return 0;
    let millionth = amt / 1000000;
    return Math.round(millionth * 10) / 10;
  }

  private aggregator() {
    const countryList = Object.keys(this.capexData[this.timeFrameMode]);
    const aggData = countryList.map((el) => {
      const sum = this.capexData[this.timeFrameMode][el].reduce((sum, item) => (sum = sum + item), 0);
      el = el.replaceAll('_', ' ');

      return { label: el, value: this.formatNumbers(sum), prefix: '$', suffix: 'MM' };
    });
    return aggData;
  }
}
